import axios from "axios";
import * as Sentry from "@sentry/react";

import store from "../app/store";
import { startLoading, stopLoading } from "../features/ui/uiSlice";
import json from "../secret.json";

const API_BASE_URL = json.API_BASE_URL;

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    store.dispatch(startLoading());
    return config;
  },
  (error) => {
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);

// 응답 인터셉터
instance.interceptors.response.use(
  (response) => {
    store.dispatch(stopLoading());
    return response;
  },
  async (error) => {
    store.dispatch(stopLoading());
    alert("오류가 발생했습니다.");
    Sentry.captureException(error);
    return Promise.reject(error);
  }
);

const apiClient = {
  async get(endpoint, config = {}) {
    const response = await instance.get(endpoint, config);
    return response;
  },

  async post(endpoint, data, config = {}) {
    const response = await instance.post(endpoint, data, config);
    return response;
  },

  async put(endpoint, data) {
    const response = await instance.put(endpoint, data);
    return response;
  },

  async delete(endpoint) {
    const response = await instance.delete(endpoint);
    return response;
  },

  // put, delete 등 필요 시 추가
};

export default apiClient;
